<template>
    <div class="task-prop task-prop_status">
        <strong>Статус:</strong>

        <Select
            name="task-status"
            :items="list"
            :active="active"
            @selectChange="v => $emit('update', v)"
        />
    </div>
</template>

<script>
export default {
    name: "Status",
    props: ['list', 'active'],
}
</script>
